import React from "react";
import { useSnackbar } from "notistack";
import { ToastVariant } from "components/ToastMessage/ToastMessage.types";
import get from "lodash/get";
import isString from "lodash/isString";
import { serviceContainer } from "services/serviceContainer";

const LOG_PREFIX = "useToast::";

export const useToast = () => {
  const { enqueueSnackbar } = useSnackbar();
  const logger = serviceContainer.cradle.logger;

  const enqueueToast = React.useCallback(
    (message: string, variant: ToastVariant) => {
      enqueueSnackbar({ message, variant });
    },
    [enqueueSnackbar]
  );

  const toastError = React.useCallback(
    (e: unknown) => {
      if (isString(e)) {
        enqueueToast(e, ToastVariant.Error);
        return;
      }

      const message = get(e, "message");
      if (e && isString(message)) {
        enqueueToast(message, ToastVariant.Error);
        return;
      }

      logger.warn(LOG_PREFIX, "Invalid error type: ", e);
    },
    [enqueueToast, logger]
  );

  const toastSuccess = React.useCallback(
    (message: string) => {
      enqueueToast(message, ToastVariant.Success);
    },
    [enqueueToast]
  );

  const toastWarning = React.useCallback(
    (message: string) => {
      enqueueToast(message, ToastVariant.Warning);
    },
    [enqueueToast]
  );

  const toastInfo = React.useCallback(
    (message: string) => {
      enqueueToast(message, ToastVariant.Info);
    },
    [enqueueToast]
  );

  return { enqueueToast, toastError, toastSuccess, toastWarning, toastInfo };
};
